import styled from 'styled-components';

export const MapMiniTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  color: ${({ theme }) => theme.colors.text};

  .map-mini-table-title {
    white-space: nowrap;
    padding: 6px;
    padding-top: 0;
    margin-bottom: 8px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    font-size: 0.8rem;
    text-transform: uppercase;
    text-align: center;
  }

  .coverage-table {
    td {
      border-right: 1px solid ${({ theme }) => theme.colors.border};
      border-bottom: 1px solid ${({ theme }) => theme.colors.border};
      font-size: 0.8rem;
      font-weight: bold;
      opacity: 0.8;
    }
    .td-signal-bars {
      padding: 6px;
    }
    th {
      padding-bottom: 8px;
      font-size: 0.8rem;
    }
  }
`;

export const MapNoCoverageContainer = styled.div`
  padding: 20px;
  min-width: 200px;

  > div {
    margin: 0 auto;
    margin-top: 8px;
  }

  p {
    font-size: 1rem;
    text-align: center;
    margin: 12px;
    color: ${({ theme }) => theme.colors.text};
  }

  .no-coverage-table-icon {
    color: ${({ theme }) => theme.colors.red};
    opacity: 0.6;
    margin: 0;
    svg {
      font-size: 1.2rem;
    }
  }
`;
